import { LocaleOption, Locales } from '@/services/locales';
import { useI18n } from 'vue-i18n';
import { computed, ComputedRef } from 'vue';
import useReservationStore from '@/composables/store/useReservationStore';

export default function useLocaleSwitcher(): {
  locales: LocaleOption[];
  currentLocale: ComputedRef<LocaleOption | undefined>;
  switchLocale: (newLocale: string) => void;
} {
  const { locale } = useI18n({ useScope: 'global' });
  const { setLocale } = useReservationStore();
  const locales: LocaleOption[] = Locales.getLocales();
  const currentLocale: ComputedRef<LocaleOption | undefined> = computed(() => {
    return Locales.getLocaleById(locale.value);
  });

  const setLocaleInReservation = (): void => {
    if (currentLocale.value) {
      setLocale(currentLocale.value?.id);
      return;
    }
    setLocale('en-US');
  };

  const switchLocale = (newLocale: string): void => {
    locale.value = newLocale;
    localStorage.setItem('language', newLocale);
    document.documentElement.lang = newLocale;
    setLocaleInReservation();
  };

  if (localStorage['language']) {
    switchLocale(localStorage['language']);
  }

  setLocaleInReservation();

  return {
    locales,
    currentLocale,
    switchLocale,
  };
}
